import SettingsDefault from "../components/Settings/Default";
import SpecialEditions from "../components/Settings/SpecialEditions/Editions.vue";
import ConfigurationListing from "../components/Settings/System/Listing";
import ConfigurationUpdate from "../components/Settings/System/Update";

const routes = [
  {
    path: "/settings",
    component: SettingsDefault,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "config",
        name: "configurationListing",
        component: ConfigurationListing,
        meta: {
          requiresAuth: true,
          description: "Settings: System Configuration",
        },
      },
      {
        path: "config/update",
        name: "configurationUpdate",
        component: ConfigurationUpdate,
        meta: {
          requiresAuth: true,
          description: "Settings: Update System Configuration",
        },
      },
      {
        path: "special-editions",
        name: "specialEditions",
        component: SpecialEditions,
        meta: {
          requiresAuth: true,
          description: "Settings: Special editions",
        },
      },
    ],
  },
];

export default routes;
